import { useNuxtApp } from 'nuxt/app';
import { useContentMenusStore } from '~~/common/stores/contentMenus';

/**
 * Career breadcrumb helpers shared across the career pages and AwCareerMenu.
 * Centralises the "career home" breadcrumb element (its i18n token and the
 * career landing link) so the trail is built consistently everywhere.
 */
export function useCareerBreadcrumbs () {
  const { $awt } = useNuxtApp();
  const contentMenusStore = useContentMenusStore();

  function careerHomeBreadcrumb (disabled: boolean) {
    return {
      token: $awt('aw.pages.career.title'),
      to: contentMenusStore.careerHomeLink,
      disabled,
    };
  }

  return { careerHomeBreadcrumb };
}
